/** The subscription modals; only one is open at a time, for one subscription. */
export enum SubscriptionModal {
  Details = 'details',
  ChangeProduct = 'change-product',
  Discount = 'discount',
  Pause = 'pause',
  ChangePause = 'change-pause',
  Resume = 'resume',
  Cancel = 'cancel',
  PremiumTemplate = 'premium-template',
  AutoRenew = 'auto-renew',
  Split = 'split',
  ChargeNow = 'charge-now',
}

/** `errors.reason` of a `409` from `POST …/charge-now`. */
export enum SubscriptionChargeNowConflict {
  InProgress = 'in_progress',
  Changed = 'changed',
}

/** `errors.reason` of a `422` refusal that the charge dialog words itself; any other reason shows its message alone. */
export enum SubscriptionChargeNowRefusal {
  Declined = 'declined',
}

/** The discount modal picks a percentage first, then asks to confirm it. */
export enum SubscriptionDiscountStep {
  Select = 'select',
  Confirm = 'confirm',
}
